export default class PaymentXmlsSelector {
  static selectPaymentXml = (state: ReduxState) => state.paymentXml.model.data;

  static selectPaymentXmls = (state: ReduxState) => state.paymentXml.list.data;

  static selectPaymentXmlIsLoading = (state: ReduxState) => state.paymentXml.model.isLoading;

  static selectPaymentXmlsIsLoading = (state: ReduxState) => state.paymentXml.list.isFetchLoading;
}
